// Pushover
const pushoverDocsLink =
  'https://docs.influxdata.com/kapacitor/latest/nodes/alert_node/#pushover'
export const PUSHOVER_DOCS_LINK = `<p>Need help setting up Pushover?<br/>Check out <a href='${pushoverDocsLink}' target='_blank'>the docs here</a>.</p>`

// Telegram
const telegramChatIDLink =
  'https://docs.influxdata.com/kapacitor/latest/guides/event-handler-setup/#telegram-chat-id'
export const TELEGRAM_CHAT_ID_TIP = `<p>Need help finding your chat id?<br/>Check out <a target='_blank' href='${telegramChatIDLink}'>these steps</a>.</p>`

const telegramTokenLink =
  'https://docs.influxdata.com/kapacitor/latest/guides/event-handler-setup/#telegram-api-access-token'
export const TELEGRAM_TOKEN_TIP = `<p>Need help finding your token?<br/>Check out <a target='_blank' href='${telegramTokenLink}'>these steps</a>.</p>`
